import React from 'react';
import ParentComponent from '../../lib/ParentComponent';
import { NavLink } from 'react-router-dom';

export default class Header extends ParentComponent {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    toggleSidebar = () => {
        this.$('#sidebar').toggleClass('opened');
    };

    render() {
        return (
            <div className="d-flex justify-content-between flex-row bg-light p-3">
                <button onClick={this.toggleSidebar} className="pl-3 pr-3 pt-2 pb-2 btn bg-transparent border-0 sidebartoggler waves-effect waves-light" data-sidebartype="mini-sidebar">
                    <i className="sl-icon-menu font-20"></i>
                </button>
                <NavLink to="/" className="d-inline-block">
                    <span className="pl-2 pr-2 text-info">EGYPTIANCOACH</span>
                    <img src="./assets/images/logo.png" alt="EgyptianCoach" className="logo-small" />
                </NavLink>
            </div>
        );
    }
};
